export const formatKey = (key) => {
  const words = key.match(/[a-z]+|[A-Z][a-z]*/g);
  // Capitalize the first letter of each word
  const formattedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  // Join the words with a space
  return formattedWords ? formattedWords.join(" ").replace("Is", "") : key;
};
